export default "__VITE_ASSET__5ne$KbB___"